import React, { useState } from 'react';
import DialogModal from 'tradera-components/dialog/dialog-modal';
import ModalContainer from 'components/modals/modal-container';
import ModalHeader from 'components/modals/modal-header';
import ModalBody from 'components/modals/modal-body';
import { Trans, useTranslator, useUrlLocalizer } from 'tradera-lang/translate';
import { useSelector } from 'react-redux';
import {
    selectIsPreferredCurrencySEK,
    selectPreferredCurrency
} from 'tradera-state/multi-currency/selectors';
import InfoIcon from '@tradera/blueprint/theme/icons2/info.svg?jsx';

export const BinModalCurrencyConversionInfoModal = () => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const currency = useSelector(selectPreferredCurrency).code;
    const [visible, setVisible] = useState(false);
    const isPreferredCurrencySEK = useSelector(selectIsPreferredCurrencySEK);

    if (isPreferredCurrencySEK) {
        return null;
    }

    return (
        <>
            <div className="d-flex align-items-center">
                <InfoIcon className="icon icon-md icon-dark mr-1" />{' '}
                <Trans
                    i18nKey="checkout_bin_currency_conversion_info_Trans"
                    components={{
                        readMoreLink: (
                            <button
                                onClick={() => setVisible(true)}
                                className="link clear-button unbutton ml-1"
                            />
                        )
                    }}
                />
            </div>
            {visible && (
                <DialogModal>
                    <ModalContainer className="h-auto">
                        <ModalHeader
                            className="border-bottom mt-0"
                            onClose={() => setVisible(false)}>
                            {t('vip_bid_currency_conversion_info_header')}
                        </ModalHeader>
                        <ModalBody className="justify-content-center position-relative p-3">
                            <Trans
                                i18nKey="vip_bin_currency_conversion_info_body_Trans"
                                values={{ currency }}
                                components={{
                                    settingsLink: (
                                        <a
                                            href={toLocalizedUrl(
                                                '/my/settings/localization'
                                            )}
                                            className="link"
                                            target="_blank"
                                            rel="noreferrer"
                                        />
                                    ),
                                    strong: (
                                        <mark className="font-weight-bold" />
                                    )
                                }}
                            />
                        </ModalBody>
                    </ModalContainer>
                </DialogModal>
            )}
        </>
    );
};
